export default function base64decode(input){
    return atob(input);
    
    }